"use strict";

/**
 * Show banner inside video list
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  /**
   * @returns {boolean}
   */
  function isEnabled() {
    var _Flix$routeArgs$page;
    return Flix.ads.enabled
    /** Only on the 1st page */ && ((_Flix$routeArgs$page = Flix.routeArgs['page']) !== null && _Flix$routeArgs$page !== void 0 ? _Flix$routeArgs$page : 1) == 1
    // Should be enough videos in the list
    && !!document.querySelector('.video-list [data-num="8"]');
  }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      // mobile mediabuys only
      if (!FlixUtils.isMobile() || !Flix.ads.isSpecificBuy()) {
        return;
      }
      var html = "\n            <div class=\"col-xs-6 col-md-4 col-xl-3 mb-3\">\n                <!-- Ads Managed by AdSpyglass.com -->\n                <iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" style=\"width:100%\"\n                sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350854?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\" title=\"ads\"></iframe>\n            </div>\n            ");
      document.querySelector('.video-list [data-num="8"]').insertAdjacentHTML('afterend', html);
    } else {
      var zoneId = FlixUtils.isMobile() ? 4401238 : 4505270;
      var html = "\n            <div class=\"col-xs-6 col-md-4 col-xl-3 mb-3\">\n                <div class=\"_nativeAd\">\n                    <img class=\"_nativePlaceholder\" src=\"/assets/img/empty.jpg\">\n                    <span class=\"_nativeLabel\">AD</span>\n                </div>\n            </div>\n            ";
      document.querySelector('.video-list [data-num="8"]').insertAdjacentHTML('afterend', html);

      /** Prepare Exo script */
      var s = document.createElement('script');
      s.src = 'https://a.realsrv.com/nativeads-v2.js';
      s.setAttribute('data-idzone', zoneId);

      /** Ad Exo script to all "._nativeAd" containers */
      document.querySelectorAll('._nativeAd').forEach(function (el) {
        return el.appendChild(s);
      });
    }
  }
})();